var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscriptionSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 172,
    height: 238,
    viewBox: "0 0 172 238",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.952 203.81H40.2854C32.6664 203.81 26.4758 197.619 26.4758 190V47.7382C26.4758 40.1192 32.6664 33.9287 40.2854 33.9287H111.952C119.571 33.9287 125.762 40.1192 125.762 47.7382V190C125.762 197.619 119.571 203.81 111.952 203.81Z",
    fill: "#1D1E2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.642 197.62H41.5948C36.4757 197.62 32.3091 193.453 32.3091 188.334V49.2862C32.3091 44.1672 36.4757 40.0005 41.5948 40.0005H110.642C115.761 40.0005 119.928 44.1672 119.928 49.2862V188.453C119.809 193.572 115.761 197.62 110.642 197.62Z",
    fill: "#D0E9E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5234 45.9525H59.2139C55.8805 45.9525 53.1425 43.2144 53.1425 39.8811V35.8335H101.476V39.8811C101.476 43.2144 98.8567 45.9525 95.5234 45.9525Z",
    fill: "#1D1E2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.309 88.3335H73.8567V93.8097H112.309V88.3335Z",
    fill: "#10A67B",
    fillOpacity: 0.24
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.309 96.4292H84.4519V101.905H112.309V96.4292Z",
    fill: "#10A67B",
    fillOpacity: 0.24
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8566 106.31H43.2614C41.3566 106.31 39.928 104.762 39.928 102.976V87.3812C39.928 85.4764 41.4757 84.0479 43.2614 84.0479H58.8566C60.7613 84.0479 62.1899 85.5955 62.1899 87.3812V102.976C62.309 104.762 60.7613 106.31 58.8566 106.31Z",
    fill: "#10A67B",
    fillOpacity: 0.24
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1188 87.6196L44.5712 98.0958C44.5712 98.0958 46.2378 100.953 51.1188 100.953C55.9997 100.953 57.6664 98.0958 57.6664 98.0958L51.1188 87.6196Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7378 99.7622C43.7378 99.7622 46.1188 102.619 50.9997 102.619C55.8807 102.619 58.2616 99.7622 58.2616 99.7622",
    stroke: "white",
    strokeWidth: 0.9686,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.309 114.644H73.8567V120.12H112.309V114.644Z",
    fill: "#10A67B",
    fillOpacity: 0.24
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.309 122.858H84.4519V128.334H112.309V122.858Z",
    fill: "#10A67B",
    fillOpacity: 0.24
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8566 132.738H43.2614C41.3566 132.738 39.928 131.191 39.928 129.405V113.81C39.928 111.905 41.4757 110.477 43.2614 110.477H58.8566C60.7613 110.477 62.1899 112.024 62.1899 113.81V129.405C62.309 131.191 60.7613 132.738 58.8566 132.738Z",
    fill: "#10A67B",
    fillOpacity: 0.24
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.309 61.9048H73.8567V67.381H112.309V61.9048Z",
    fill: "#10A67B",
    fillOpacity: 0.24
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M112.309 70H84.4519V75.4762H112.309V70Z",
    fill: "#10A67B",
    fillOpacity: 0.24
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8566 79.881H43.2614C41.3566 79.881 39.928 78.3334 39.928 76.5477V60.9525C39.928 59.0477 41.4757 57.6191 43.2614 57.6191H58.8566C60.7613 57.6191 62.1899 59.1667 62.1899 60.9525V76.5477C62.309 78.3334 60.7613 79.881 58.8566 79.881Z",
    fill: "#10A67B",
    fillOpacity: 0.24
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8565 77.262H48.3804L47.0708 67.0239H55.047L53.8565 77.262Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8805 66.3097H46.3567L46.7138 64.6431H55.4043L55.8805 66.3097Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9516 63.9287H50.9993L52.4278 60.3573C52.5468 60.2382 52.6659 60.1191 52.785 60.1191H54.6897V60.9525H53.023L51.9516 63.9287Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M154.809 235.834L124.809 205.834L133.737 196.905L163.737 226.905C166.237 229.405 166.237 233.334 163.737 235.834C161.237 238.215 157.309 238.215 154.809 235.834Z",
    fill: "#1D1E2C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M121.118 209.048L117.785 205.715L133.618 189.881L136.952 193.215C139.094 195.358 139.094 198.81 136.952 200.834L128.737 209.048C126.594 211.072 123.142 211.072 121.118 209.048Z",
    fill: "#F18F01"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4518 200.953C21.1184 177.619 21.1184 139.762 44.4518 116.429C67.7851 93.0954 105.642 93.0954 128.976 116.429C152.309 139.762 152.309 177.619 128.976 200.953C105.642 224.286 67.6661 224.286 44.4518 200.953ZM118.976 126.429C101.118 108.572 72.1899 108.572 54.3327 126.429C36.4756 144.286 36.4756 173.214 54.3327 191.072C72.1899 208.929 101.118 208.929 118.976 191.072C136.833 173.214 136.833 144.286 118.976 126.429Z",
    fill: "#C1DCD6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0828 200.618C20.7388 177.278 20.7388 139.242 44.0828 116.045C67.4267 92.7049 105.469 92.7049 128.669 116.045C152.013 139.386 152.013 177.422 128.669 200.762C105.325 223.959 67.4267 223.959 44.0828 200.618ZM125.498 119.215C103.884 97.6036 68.8677 97.6036 47.253 119.215C25.6382 140.827 25.6382 175.837 47.253 197.449C68.8677 219.06 103.884 219.06 125.498 197.449C147.113 175.837 147.113 140.827 125.498 119.215Z",
    fill: "#10A67B",
    fillOpacity: 0.24
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M131.658 169.413C137.592 144.602 122.288 119.678 97.4769 113.744C72.6656 107.811 47.7418 123.114 41.8081 147.925C35.8744 172.736 51.1777 197.66 75.9891 203.594C100.8 209.528 125.724 194.224 131.658 169.413Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M154.452 112.976L122.547 144.881L100.404 122.738L107.428 115.715L122.547 130.834L147.428 105.953L154.452 112.976Z",
    fill: "#10A67B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M113.024 185.001H61.8335C59.0954 185.001 56.8335 182.739 56.8335 180V176.905C56.8335 174.167 59.0954 171.905 61.8335 171.905H113.024C115.762 171.905 118.024 174.167 118.024 176.905V180C118.024 182.858 115.762 185.001 113.024 185.001Z",
    fill: "#CA7A07"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1432 170.238L56.2384 177.619C56.0003 178.691 57.0717 179.643 58.1432 179.167L75.8812 171.429H85.7622L97.905 180.834C98.3812 181.191 99.0955 181.191 99.5717 180.834L111.476 171.429H113.857L117.191 176.548C117.429 176.905 118.024 176.667 117.905 176.191L116.357 170.476L58.1432 170.238Z",
    fill: "#F18F01"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M113.024 172.024H61.8335C59.0954 172.024 56.8335 169.762 56.8335 167.024V163.929C56.8335 161.191 59.0954 158.929 61.8335 158.929H113.024C115.762 158.929 118.024 161.191 118.024 163.929V167.024C118.024 169.762 115.762 172.024 113.024 172.024Z",
    fill: "#EB4D4B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4524 154.405C59.4524 154.405 54.6905 159.167 55.2857 160.834C56 162.5 57.6667 160.953 60.6429 160.239C63.6191 159.405 65.1667 159.405 65.7619 161.072C66.2381 162.739 64.9286 163.81 67.1905 164.524C69.3334 165.239 70.2857 161.905 72.5477 162.024C74.8096 162.143 75.7619 162.381 76.8333 163.453C77.7857 164.524 78.1429 165 79.6905 165.12C81.2381 165.239 81.4762 161.905 83.6191 161.072C85.7619 160.239 85.5238 160.715 87.4286 161.429C89.3334 162.143 91.3572 161.31 92.6667 160.119C93.9763 158.929 95.881 158.81 96.7143 160.834C97.5476 162.858 98.6191 166.786 100.167 167.262C101.714 167.739 103.5 167.977 104.452 165.715C105.405 163.453 105.048 159.643 107.071 159.643C109.214 159.762 108.738 160.834 109.929 162.024C111.119 163.334 113.262 162.62 113.738 162.143C114.214 161.667 113.262 159.286 114.81 159.643C119.333 160.596 117.786 157.977 116 154.167C114.095 150.477 59.4524 154.405 59.4524 154.405Z",
    fill: "#BADC58"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M115.047 155.834H59.9283C58.2617 155.834 56.9521 154.524 56.9521 152.858C56.9521 141.548 66.1188 132.5 77.3093 132.5H97.5474C108.857 132.5 117.904 141.667 117.904 152.858C118.024 154.524 116.714 155.834 115.047 155.834Z",
    fill: "#CA7A07"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2622 134.048L70.7622 136.191",
    stroke: "#FFBE76",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0718 138.333L84.5718 140.595",
    stroke: "#FFBE76",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8813 134.405L81.4766 137.262",
    stroke: "#FFBE76",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5003 134.762L92.667 137.738",
    stroke: "#FFBE76",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M102.667 134.762L104.096 137.024",
    stroke: "#FFBE76",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5715 138.333L76.0001 140.595",
    stroke: "#FFBE76",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2621 138.69L99.5717 141.071",
    stroke: "#FFBE76",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M171 165.953C171 169.405 168.143 172.262 164.69 172.262C161.238 172.262 158.381 169.405 158.381 165.953C158.381 162.5 161.238 159.643 164.69 159.643C168.143 159.643 171 162.5 171 165.953Z",
    stroke: "#10A67B",
    strokeOpacity: 0.24,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M138.619 16.3095C138.619 19.7619 135.761 22.619 132.309 22.619C128.857 22.619 126 19.7619 126 16.3095C126 12.8571 128.857 10 132.309 10C135.761 10 138.619 12.8571 138.619 16.3095Z",
    stroke: "#10A67B",
    strokeOpacity: 0.24,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4523 129.405C14.4523 132.857 11.5952 135.714 8.14284 135.714C4.69045 135.714 1.83325 132.857 1.83325 129.405C1.83325 125.952 4.69045 123.095 8.14284 123.095C11.5952 123.095 14.4523 125.952 14.4523 129.405Z",
    stroke: "#10A67B",
    strokeOpacity: 0.24,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1188 218.453C16.1188 218.453 16.2379 208.095 26.476 208.095C26.476 208.095 16.1188 207.976 16.1188 197.738C16.1188 197.738 15.9998 208.095 5.76172 208.095C5.76172 208.095 16.1188 208.214 16.1188 218.453Z",
    fill: "#F18F01"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9285 20.7143C39.9285 20.7143 40.0476 10.3572 50.2857 10.3572C50.2857 10.3572 39.9285 10.2381 39.9285 0C39.9285 0 39.8095 10.3572 29.5714 10.3572C29.5714 10.3572 39.9285 10.4762 39.9285 20.7143Z",
    fill: "#F18F01"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M160.524 92.143C160.524 92.143 160.643 81.7859 170.881 81.7859C170.881 81.7859 160.524 81.6668 160.524 71.4287C160.524 71.4287 160.405 81.7859 150.167 81.7859C150.286 81.7859 160.524 81.9049 160.524 92.143Z",
    fill: "#F18F01"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4286 225.714C32.4286 225.714 32.5477 219.643 38.5001 219.643C38.5001 219.643 32.4286 219.524 32.4286 213.571C32.4286 213.571 32.3096 219.643 26.3572 219.643C26.3572 219.643 32.4286 219.762 32.4286 225.714Z",
    fill: "#F18F01"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M70.524 22.3812C70.524 22.3812 70.6431 16.3097 76.5955 16.3097C76.5955 16.3097 70.524 16.1907 70.524 10.2383C70.524 10.2383 70.405 16.3097 64.4526 16.3097C64.4526 16.3097 70.524 16.3097 70.524 22.3812Z",
    fill: "#F18F01"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0714 70.2381C7.0714 70.2381 7.19042 64.1667 13.1428 64.1667C13.1428 64.1667 7.0714 64.0476 7.0714 58.0952C7.0714 58.0952 6.95238 64.1667 1 64.1667C1 64.1667 7.0714 64.1666 7.0714 70.2381Z",
    fill: "#F18F01"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M145.286 67.1429C145.286 67.1429 145.405 61.0714 151.357 61.0714C151.357 61.0714 145.286 60.9524 145.286 55C145.286 55 145.167 61.0714 139.215 61.0714C139.215 61.0714 145.286 61.1905 145.286 67.1429Z",
    fill: "#F18F01"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionSuccess);
export default __webpack_public_path__ + "static/media/subscription_success.4fd3873666a3ec4e0533d57612ae574f.svg";
export { ForwardRef as ReactComponent };